import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
// Components
import OMLabelTop from '../../OMComponents/OMLabelTop/OMLabelTop';
import OMSegmentedControl from '../../OMComponents/OMSegmentedControl/OMSegmentedControl';
// Helpers
import clearNumber from '../../../helpers/clearNumber';
import beautifyNumber from '../../../helpers/beautifyNumber';
import { calculatePriceForOneProperty } from '../../../helpers/paymentCalculation';
import { getPackagePeriods } from '../../../packagesData';
// Styles
import * as styles from '../PackageItem.scss';
import {
  PACKAGE_FEATURES_ORDER,
  PROMOTIONS
} from '../../../containers/RealtorPackagesContainer/packagesConfigs';

class RealtorPackageDetails extends Component {
  state = {
    periods: getPackagePeriods(true)
  };

  shouldComponentUpdate(nextProps) {
    const periodIsChanged = (nextProps.selectedPackage.period !== this.props.selectedPackage.period);
    const localeIsChanged = (nextProps.locale !== this.props.locale);
    return (periodIsChanged || localeIsChanged);
  }

  defineMonthTitle = (quantity) => (quantity === 12) ? 'yearly' : 'monthly';

  renderPromoIcon = (promotion) => {
    switch (promotion) {
      case PROMOTIONS.TOP_AD: return (<OMLabelTop label="TOP" title="TOP" />);
      case PROMOTIONS.HIGHLIGHTS: return (
        <span className="icon icon-promoted-active" >
          <i className="path1" />
          <i className="path2" />
          <i className="path3" />
        </span>
        );
      case PROMOTIONS.AUTO_JUMPS: return (
        <span className="icon icon-auto-jump-active" >
          <i className="path1" />
          <i className="path2" />
          <i className="path3" />
        </span>
        );
      default: return '';
    }
  };

  renderOnePropertyPriceTitle = (selectedPeriod) => {
    const price = get(this.props, `packageData.period[${selectedPeriod}].price`);
    const beautifiedPrice = beautifyNumber(clearNumber(price));
    return <span className={styles.priceTitle}>{`₪${beautifiedPrice}`} <span>{this.props.translate('perMonth')}</span></span>;
  };

  renderPeriodSelection = (selectedPeriod) => (
    <div className={styles.period}>
      <OMSegmentedControl
        name="period"
        className="rounded"
        theme="gray"
        selectedValue={selectedPeriod}
        values={this.state.periods.map(item => ({
          value: item,
          label: `${this.props.translate(this.defineMonthTitle(item))}`
        }))}
        onChange={period => this.props.changeSelectedPayment({ period })}
      />
      <span className={styles.monthPayment}>{this.renderOnePropertyPriceTitle(selectedPeriod)}</span>
    </div>
  );

  renderFeature = (feature) => {
    const { translate, packageData, selectedPackage } = this.props;
    const selectedPeriod = selectedPackage.period;

    const featuresData = get(packageData, `period[${selectedPeriod}]`, {});

    const value = featuresData[feature];
    const status = (!!value) ? 'check' : 'close2';
    const title = translate(`promo_${feature}`);
    const xCount = (!!value && typeof value === 'number') ? `x ${value}` : '';
    const duration = (feature === PROMOTIONS.TOP_AD && !!xCount) ? translate('forOneMonth') : '';
    const directionMark = this.props.isRtl ? '\u200F' : '';

    const promotionIcon = !!xCount ? this.renderPromoIcon(feature) : '';

    return (
      <div
        key={`${packageData.id}_${feature}`}
        className={cx(styles.featureItem, { [styles.disabledFeature]: !value })}
      >
        <span className={`icon icon-${status}`} />
        {(feature === PROMOTIONS.PROPERTIES)
          ? (<span>{value} {title}</span>)
          : (
              <span>{title}&nbsp;
                <span className={styles.bold}>
                  {directionMark}{xCount}
                </span>&nbsp;{duration}
              </span>
          )
        }
        <span className={styles.promoIcon}>&nbsp;{promotionIcon}</span>
      </div>
    );
  };

  render() {
    const selectedPeriod = this.props.selectedPackage.period;

    return (
      <div>
        <div className={styles.packageFeatures}>{PACKAGE_FEATURES_ORDER.map(this.renderFeature)}</div>
        { this.renderPeriodSelection(selectedPeriod) }
      </div>
    );
  }
}

RealtorPackageDetails.propTypes = {
  translate: PropTypes.func,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  locale: PropTypes.string,
  packageData: PropTypes.object,
  selectedPackage: PropTypes.object,
  changeSelectedPayment: PropTypes.func
};

export default RealtorPackageDetails;
